import { select } from 'd3-selection';

export function pixelsToUserSpace(element, { x=0, y=0 }) {
  const { ownerSVGElement } = element;
  if (!ownerSVGElement) {
    return {
      x: 0,
      y: 0,
    };
  }
  const pt = ownerSVGElement.createSVGPoint();
  const ctm = element.getScreenCTM().inverse();
  pt.x = x;
  pt.y = y;
  const transformed = pt.matrixTransform(ctm);
  return transformed;
};

export function userSpaceToPixels(element, { x=0, y=0 }) {
  const { ownerSVGElement } = element;
  if (!ownerSVGElement) {
    return {
      x: 0,
      y: 0,
    };
  }
  const pt = ownerSVGElement.createSVGPoint();
  const ctm = element.getScreenCTM();
  pt.x = x;
  pt.y = y;
  const transformed = pt.matrixTransform(ctm);
  return transformed;
};

const layoutPadding = 5;

function layoutContainer() {
  const elements = select(this).selectAll('.adjustLayout');
  if (elements.empty()) {
    return;
  }
  const nodes = elements.nodes();
  const sortedNodes = [...nodes].sort(function sortByXCoord(a,b) {
    return a.getBoundingClientRect().x - b.getBoundingClientRect().x;
  });
  let currentX = sortedNodes[0].getBoundingClientRect().x;

  const adjustments = sortedNodes.map((n) => {
    const coords = n.getBoundingClientRect();
    const adjustment = {
      coords,
      right: Math.max(currentX - coords.x, 0),
    }
    currentX = coords.x + adjustment.right + coords.width + layoutPadding;
    return adjustment;
  });

  sortedNodes.reverse();
  adjustments.reverse().forEach(function adjust(a, i) {
    a.left = Math.min(currentX - a.coords.x - a.coords.width, 0);
    currentX = a.coords.x + a.left - layoutPadding;
    if (a.left + a.right) {
      const node = sortedNodes[i];
      const xPixels = node.getBoundingClientRect().x;
      const x = pixelsToUserSpace(node, { x: xPixels }).x;
      const adjusted = pixelsToUserSpace(node, { x: xPixels + (a.left + a.right) / 2 }).x;
      select(node).attr('transform', `translate(${adjusted - x}, 0)`);
    }
  });
}

export function layout(selection) {
  selection.each(layoutContainer);
};

export function adjustLayout(selection) {
  function update() {
    selection.selectAll('.adjustLayout').attr('transform', null);
    layout(selection);
  }
  window.requestAnimationFrame(update);
}
